export const TRAINING = "training";
export const TOURNAMENT = "tournament";
